import {workplaceTypes} from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import {HeaderMenuBlock} from "../Block/HeaderMenuBlock/HeaderMenuBlock";
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

const VehicleList = {
    time: null,
    list: [],
    init: function () {
        return m.request({
            method: 'GET',
            url: '/api/vehicle'
        }).then(function (response) {
            server.setOnline();
            VehicleList.time = response.time;
            
            // Преобразуем в массив объектов с id
            VehicleList.list = response.vehicles.map(function (item) {
                return {
                    id: item.id,
                    type: item.type,
                    number: item.number
                };
            });

            loader.hide();
            storage.config = response.config;
            server.initPing();

            return response;
        }, function (response) {
            if (!response) {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

export const SelectVehiclePage = {
    controller: function () {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (!user.has('state.workplace')) {
            m.route('/workplace');
            return;
        }
        if (user.get('state.workplace') !== workplaceTypes.driver) {
            m.route('/');
            return;
        }

        interval.clearAll();
        loader.show();

        const data = VehicleList.init();
        
        // Инициализация свойств
        self.filterText = m.prop('');
        self.selectedVehicle = m.prop(null);
        self.errmsg = '';

        return {
            data: data,
            topMenu: [
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' },
            ],
            
            // Геттеры для свойств
            filterText: function() {
                return self.filterText();
            },
            
            setFilterText: function(value) {
                self.filterText(value);
            },
            
            selectedVehicle: function() {
                return self.selectedVehicle();
            },
            
            // Функция фильтрации списка
            getFilteredVehicles: function() {
                const filterValue = self.filterText();
                if (!filterValue) {
                    return VehicleList.list;
                }
                const filter = filterValue.toLowerCase();
                return VehicleList.list.filter(function(vehicle) {
                    return vehicle.number.toLowerCase().includes(filter);
                });
            },
            
            // Функция выбора транспорта
            selectVehicle: function(vehicle) {
                self.selectedVehicle(vehicle);
            },
            
            // Функция подтверждения выбора
            confirmSelection: function(e) {
                if (e) e.preventDefault();
                
                self.errmsg = '';
                const selected = self.selectedVehicle();
                
                if (!selected || !selected.id) {
                    self.errmsg = 'Транспорт не выбран';
                    return;
                }

                const data = {
                    id: parseInt(selected.id),
                    type: selected.type
                };

                m.request({
                    method: 'POST',
                    url: '/api/vehicle',
                    data: data
                }).then(function (response) {
                    server.setOnline();
                    loader.hide();
                    storage.config = response.config;

                    user.set('state.vehicle', data.id);
                    user.set('state.vehicleType', data.type);
                    user.set('state.vehicleNumber', selected.number);

                    user.set('state.vehicleFreeTasksAvailable', response.config.vehicleFreeTasksAvailable);

                    m.route('/');
                }, function (response) {
                    if (response && response.message) {
                        self.errmsg = response.message;
                    } else {
                        server.setOffline();
                    }
                    loader.hide();
                });
            },
            
            // Геттер для ошибки
            getErrmsg: function() {
                return self.errmsg;
            }
        };
    },
    
    view: function (ctrl) {
        const filteredVehicles = ctrl.getFilteredVehicles();
        const selectedVehicle = ctrl.selectedVehicle();
        const errmsg = ctrl.getErrmsg();
        
        return [
            m.component(HeaderMenuBlock, {
                time: {},
                menu: ctrl.topMenu
            }),
            errmsg ? m(".alert.alert-danger", errmsg) : null,
            m(".container[style='margin: 15px 0']", [
                // Фильтр
                m(".form-group", [
                    m("input.form-control.input-lg[type='text'][placeholder='Поиск транспорта...']", {
                        oninput: function(e) {
                            ctrl.setFilterText(e.target.value);
                        },
                        value: ctrl.filterText(),
                        style: "margin-bottom: 15px;"
                    })
                ]),
                
                // Кнопка выбора
                m("button.btn.btn-success.btn-block.btn-lg", {
                    onclick: ctrl.confirmSelection.bind(ctrl),
                    disabled: !selectedVehicle,
                    style: "margin-bottom: 15px;"
                }, "Выбрать"),
                
                // Список транспорта
                m(".list-group", {
                    style: "max-height: calc(100vh - 250px); overflow-y: auto;"
                }, 
                    filteredVehicles.length > 0 ?
                    filteredVehicles.map(function(vehicle) {
                        const isSelected = selectedVehicle && selectedVehicle.id === vehicle.id;
                        
                        return m("a.list-group-item", {
                            onclick: function() {
                                ctrl.selectVehicle(vehicle);
                            },
                            style: {
                                cursor: "pointer",
                                backgroundColor: isSelected ? "#e8f4f8" : "white",
                                borderLeft: isSelected ? "4px solid #5bc0de" : "1px solid #ddd"
                            }
                        }, [
                            m(`h4.list-group-item-heading[data-vehicle-type-id=${vehicle.type}]`, vehicle.number)
                        ]);
                    }) :
                    m(".list-group-item.text-center", {
                        style: "color: #999;"
                    }, "Ничего не найдено")
                )
            ])
        ];
    }
};